import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../api';  // Ensure this path matches your API utility file

export const fetchPenalty = createAsyncThunk("penalty/fetchPenalty", async (searchText) => {
  const response = await api.post("/penalty", { search: searchText });
  return response.data.data;
});

// Define the initial state and slice
const penaltySlice = createSlice({
  name: "penaltyData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    error: null,
    successMessage: null,
  },
  reducers: {
    openPenaltyModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closePenaltyModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPenalty.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPenalty.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchPenalty.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { openPenaltyModal, closePenaltyModal, clearError } = penaltySlice.actions;
export default penaltySlice.reducer;
export { penaltySlice };
